/**
 * Order cards so the useful ones are on the first screen.
 *
 * The catalogue is alphabetical and ~85% of it cannot be connected at all, so
 * opening the modal showed a wall of disabled "Unavailable" buttons — 1password,
 * 21risk, 2chat — and nothing you could actually click. Connected apps first,
 * then connectable, then the rest.
 *
 * @param {{ isConnected?: boolean, canConnect?: boolean, title?: string }[]} cards
 */
export function rankToolkitCards(cards) {
  const rank = (card) => {
    if (card.isConnected) return 0
    if (card.canConnect) return 1
    return 2
  }

  return [...(cards ?? [])].sort(
    (a, b) => rank(a) - rank(b) || String(a.title ?? '').localeCompare(String(b.title ?? '')),
  )
}
